import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import ReamazeCredentialsStore from '../../../stores/credentials/reamaze-credentials-store';

interface IIntegrationProps {
    credentialsStore: ReamazeCredentialsStore,
    vGroup: IValidationGroup,
}

const ReamazeCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='Reamaze account email' required key='username'>
                <Input
                    value={credentialsStore.username}
                    onChange={v => credentialsStore.username = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Api Token' required key='api_key' note='The Api Token can be found in re:Amaze dashboard > Settings > Developer > Api Token'>
                <Input
                    value={credentialsStore.api_key}
                    onChange={v => credentialsStore.api_key = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Subdomain name' required key='brand' note='The Subdomain Name, e.g. your re:Amaze address is https://returngo.reamaze.io, then need to provide "returngo"'>
                <Input
                    value={credentialsStore.brand}
                    onChange={v => credentialsStore.brand = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Email Channel Slug Name' required key='channelName' note='Slug Name of the email channel in Reamaze where the tickets will be created'>
                <Input
                    value={credentialsStore.channelName}
                    onChange={v => credentialsStore.channelName = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default ReamazeCredentials;
